<template lang="pug">
  conference-form(
    :date="$route.query.date"
  )
</template>

<script>
import ConferenceForm from '../components/Conference/ConferenceForm.vue';

export default {
  components: {
    ConferenceForm,
  },
};
</script>
